import { useAtomValue } from "jotai";
import { loadable } from "jotai/utils";

import {
	$documentHasConflicts,
	$documentIsCollabConflict,
} from "../../internal/git/git-repository.atom";

/**
 * Hook to check if a document's working copy has unresolved conflicts.
 * Also detects whether the conflict is on a collab document (collab/main branch).
 * @param documentId - The document ID
 * @returns Whether the document has conflicts, whether it's a collab conflict, and loading state
 */
export const useDocumentHasConflicts = (documentId: string | undefined) => {
	const conflictsLoadable = useAtomValue(loadable($documentHasConflicts(documentId)));
	const collabConflictLoadable = useAtomValue(loadable($documentIsCollabConflict(documentId)));

	const hasConflicts =
		documentId && conflictsLoadable.state === "hasData" ? conflictsLoadable.data : false;
	const isCollabConflict =
		documentId && collabConflictLoadable.state === "hasData"
			? collabConflictLoadable.data
			: false;
	const isLoading = documentId ? conflictsLoadable.state === "loading" : false;

	return {
		hasConflicts,
		isCollabConflict,
		isLoading,
	};
};
